<div class="flex justify-between mb-6">
  <button mat-icon-button aria-label="Back" pdNavigateBack>
    <mat-icon>arrow_back</mat-icon>
  </button>

  <pd-app-title sizeClass="text-5xl"></pd-app-title>

  <span class="spacer"></span>
</div>

<h1>Privacy Policy</h1>
<h4>We are committed to securing your privacy.</h4>
<ul class="text-lg">
  <li>We do not share, sell, rent, or lease your private information.</li>
  <li>
    We do not share any of your personally identifiable information with other
    users on our site.
  </li>
  <li>
    We use log files and cookies to operate our site. These files do not
    track/gather/provide personally identifiable information.
    <span class="font-normal">
      <a routerLink="." fragment="cookies" class="text-sm">Learn more</a>
    </span>
  </li>
  <!-- <li>
    We use Google AdSense to display ads on our site.<br />
    <span class="font-normal text-sm">
      Google AdSense also uses cookies and beacons. We don't have access to, or
      control over, their data.
      <a routerLink="." fragment="AdSense">Learn more</a>
    </span>
  </li> -->
</ul>
<br />
<hr />
<p>
  <span id="cookies" class="font-bold">
    Log Files, Web Cookies, and Beacons
  </span>
  <br />
  Like most standard websites, this website uses log files. These include:
  Internet Protocol addresses (IP addresses), browser type, Internet Service
  Provider (ISP), referring/exit pages, platform type, date/time stamp, and the
  number of clicks to analyze trends, administer the site, track user movement
  in the aggregate, and to gather broad demographic information for aggregate
  use. IP addresses, etc., are
  <span class="font-bold">
    not linked to personally identifiable information
  </span>
  .
</p>
<p>
  Web cookies (also known as HTTP cookies, or just cookies) are parcels of text
  that are sent by a server to a Web browser, and then sent back unchanged by
  the browser each time it accesses that server. In other words, a cookie is a
  piece of data stored on a user's computer that is tied to information about
  the user.
</p>
<p>
  Web beacons are objects that are embedded in a webpage or email that are
  invisible to the user, but allow checking that a user has viewed the page or
  email. Other names are web bug, tracking bug, tag or page tag.
</p>
<!-- <p>
  Google AdSense, a service we use to display ads, may use cookies and web
  beacons as well. We have no access to, or control of their web cookies or web
  beacons (see below for more information).
</p>
<p>
  <span id="AdSense" class="font-bold">Google AdSense</span>
  We use Google AdSense to display ads on this site. These ads may contain
  cookies and/or web beacons in order to collect data in the ad serving process.
  These such cookies and/or web beacons are collected by the companies and/or
  advertising networks, themselves. We do not have any access to, or control
  over, their data. If you have any questions, please check their
  <a
    href="http://support.google.com/adsense/bin/answer.py?hl=en&answer=48182"
    target="_blank"
  >
    privacy policies
  </a>
  . Google requires us to include the following lines:
</p>
<ul>
  <li>
    Third party vendors, including Google, use cookies to serve ads based on a
    user's prior visits to your website.
  </li>
  <li>
    Google's use of the DoubleClick cookie enables it and its partners to serve
    ads to your users based on their visit to your sites and/or other sites on
    the Internet.
  </li>
  <li>
    Users may opt out of the use of the DoubleClick cookie for interest-based
    advertising by visiting the
    <a href="http://www.google.com/ads/preferences/" target="_blank">
      ads preference manager
    </a>
  </li>
</ul> -->
<p>
  <span class="font-bold">
    Sites visited before or after PersonaliDate.com
  </span>
  Please be aware that we are not responsible for the privacy practices of other
  websites. We encourage you to read the privacy policies (or privacy
  statements) of each and every website you visit, as this particular privacy
  policy applies solely to the PersonaliDate.com website.
</p>
<p>
  <span class="font-bold">Webmaster Contact Information</span>
  If you have any questions or suggestions regarding the PersonaliDate.com
  privacy policy, please feel free to
  <a href="mailto:support@PersonaliDate.com">contact us</a>.
</p>
